import { TTracking, TTrackingExport } from '~/pages/backoffice/admin/types';

export function compareBySite(a: TTracking, b: TTracking) {
  if (a.site < b.site) {
    return -1;
  }
  if (a.site > b.site) {
    return 1;
  }

  return 0;
}

export function getTrackingForExport(
  trackingsForExport: TTracking[]
): TTrackingExport[] {
  const mappedTrackings: TTrackingExport[] = [];
  for (let i = 0; i < trackingsForExport.length; i++) {
    const mapped: TTrackingExport = {
      site: trackingsForExport[i].site,
      thematique: trackingsForExport[i].thematique,
      passedTime: trackingsForExport[i].passedTime.toString() + ' sec',
      viewCount: trackingsForExport[i].viewCount.toString(),
      viewCountFinished: trackingsForExport[i].viewCountFinished.toString(),
      viewCountLeft: trackingsForExport[i].viewCountLeft.toString(),
      questionCount: trackingsForExport[i].questionCount.toString(),
      questionCountCorrect:
        trackingsForExport[i].questionCountCorrect.toString(),
      questionCountIncorrect:
        trackingsForExport[i].questionCountIncorrect.toString(),
      text: '',
    };
    mappedTrackings.push(mapped);
    for (const res of trackingsForExport[i].responsesExtended) {
      const response: TTrackingExport = {
        site: '',
        thematique: '',
        passedTime: '',
        viewCount: '',
        viewCountFinished: '',
        viewCountLeft: '',
        questionCount: '',
        questionCountCorrect: res.questionCountCorrect.toString(),
        questionCountIncorrect: res.questionCountIncorrect.toString(),
        text: res.text,
      };
      mappedTrackings.push(response);
    }
    // ajout d'une ligne supp pour la visibilité
    mappedTrackings.push({
      site: '',
      thematique: '',
      passedTime: '',
      viewCount: '',
      viewCountFinished: '',
      viewCountLeft: '',
      questionCount: '',
      questionCountCorrect: '',
      questionCountIncorrect: '',
      text: '',
    });
  }
  return mappedTrackings;
}
